import React, {useEffect, useMemo, useRef, useState, useContext} from 'react';
import TestAssignments from "./TestAssignments.js";
// import SkillSelect from "./SkillSelect.js";
import SkillSelect from "./SkillSelect1.js";

import SkillResourceSelect from "./SkillResourceSelect/SkillResourceSelect";
import {Steps} from "antd";
import Card,{CARD} from "@common/Card";
import AssignedFollowUpWork from "./AssignedFollowUpWork";
import {STEP_NUMBERS} from "./Data";
import {BrandContext} from "@context/BrandContext";

const AssignedTestsTab = (props) => {
    const {editAssignObj, refreshTestAssignmentSearch} = props,
        brandConfig = useContext(BrandContext),
        [stepNumber, setStepNumber] = useState(STEP_NUMBERS.TEST_ASSIGNMENTS.number),
        [selectedTestAssignmentData, setSelectedTestAssignmentData] = useState(null),
        [selectedTestAssignmentSkillResourceMap, setSelectedTestAssignmentSkillResourceMap] = useState({}),
        [selectedStudents, setSelectedStudents] = useState([]),
        [selectedStudentScores, setSelectedStudentScores] = useState([]),
        [studentSkillResourceIdsMap, setStudentSkillResourceIdsMap] = useState({}),
        [trackedTextbookColumnData, setTrackedTextbookColumnData] = useState([]),
        [trackedCurriculumColumnData, setTrackedCurriculumColumnData] = useState([]),
        [trackedCurriculumRowData, setTrackedCurriculumRowData] = useState([]),
        [trackedTextbookRowData, setTrackedTextbookRowData] =  useState([]),
        [trackedInitialTextbookColData, setTrackedInitialTextbookColData] = useState([]),
        [trackedDataSet, setTrackedDataSet] = useState(false),
        [trackedInitialCurriculumColData, setTrackedInitialCurriculumColData] = useState([]),
        [trackedInitialCurriculumRowData, setTrackedInitialCurriculumRowData] =  useState([]),
        [trackedInitialTextbookRowData, setTrackedInitialTextbookRowData] =  useState([]),
        [trackedRawRowResults, setTrackedRawRowResults] =  useState([]),
        [trackedRawColResults, setTrackedRawColResults] =  useState([]),
        [hasCurriculumData, setTrackedHasCurriculumData] =  useState(false),
        [trackedTextbookDataInit, setTrackedTextbookDataInit] =  useState(false),
        [trackedCurriculumDataInit, setTrackedCurriculumDataInit] =  useState(false),
        [skillSelectTrackedState, setSkillSelectTrackedState] = useState({}),
        textbookGridRef = useRef(),
        curriculumGridRef = useRef();

    const handleTestAssignmentDataChange = (testAssignmentData) => {
        setSelectedTestAssignmentData(testAssignmentData);
    }
    const updateTestAssignmentSkillResourceMap = (skillResourceMap) => {
        setSelectedTestAssignmentSkillResourceMap(skillResourceMap);
    }
    const handleUpdatedSkillResources = (value)=>{
        setStudentSkillResourceIdsMap(value);
    }
    const handleStepChange = (stepNumber)=>{
        setStepNumber(stepNumber);
        resetTrackedData(stepNumber);
    }

    const resetTrackedData = (stepNumber)=>{
        if(STEP_NUMBERS.TEST_ASSIGNMENTS.number === stepNumber){
            setTrackedTextbookColumnData([]);
            setTrackedCurriculumColumnData([]);
            setTrackedCurriculumRowData([]);
            setTrackedInitialTextbookColData([]);
            setTrackedInitialCurriculumRowData([]);
            setTrackedDataSet(false);
            setTrackedTextbookRowData([]);
            setTrackedInitialCurriculumColData([]);
            setTrackedInitialTextbookRowData([]);
            setTrackedRawRowResults([]);
            setTrackedRawColResults([]);
            setTrackedTextbookDataInit(false);
            setTrackedCurriculumDataInit(false);
        }
    }

    const handleStudentUpdate = (students)=>{
        setSelectedStudents(students);
    }
    const handleStudentScoreUpdate = (scores)=>{
        setSelectedStudentScores(scores);
    }

    const handleTrackedTextbookColData = (data)=>{
        setTrackedTextbookColumnData(data);
    }
    const handleTrackedInitialCurriculumColData = (data)=>{
        setTrackedInitialCurriculumColData(data);
    }
    const handleTrackedInitialTextbookColData = (data)=>{
        setTrackedInitialTextbookColData(data);
    }
    const handleTrackedTextbookDataInit = (data)=>{
        setTrackedTextbookDataInit(data);
    }
    const handleTrackedCurriculumDataInit = (data)=>{
        setTrackedCurriculumDataInit(data);
    }
    const handleTrackedCurriculumColData = (data)=>{
        setTrackedCurriculumColumnData(data);
    }
    const handleTrackedCurriculumRowData = (data)=>{
        setTrackedCurriculumRowData(data);
    }
    const handleTrackedTextbookRowData = (data)=>{
        setTrackedTextbookRowData(data);
    }
    const handleTrackedInitialCurriculumRowData = (data)=>{
        setTrackedInitialCurriculumRowData(data);
    }
    const handleTrackedInitialTextbookRowData = (data)=>{
        setTrackedInitialTextbookRowData(data);
    }
    const handleDataSet = (value)=>{
        setTrackedDataSet(value);
    }
    const handleUpdateRawRowResults = (value)=>{
        setTrackedRawRowResults(value);
    }
    const handleUpdateRawColResults = (value)=>{
        setTrackedRawColResults(value);
    }
    const handleUpdateHasCurriculumData = (value)=>{
        setTrackedHasCurriculumData(value);
    }
    const handleUpdateSkillSelectTrackedState = (value) => {
        setSkillSelectTrackedState(value);
    }
    const handleResetTracking = () => {
        setSkillSelectTrackedState({});
    }

    useEffect(()=>{
        document.getElementById('content').scrollTop = 0;
    },[stepNumber]);


    return (
        <div>
            <div className="flex margin-y--l">
                {/*<Card className="ch-center-elem stepper-background" boxRadius={CARD.RADIUS.EXTRA_SMALL} style={{width: '100%'}}>*/}
                    <Steps
                        size="small"
                        current={stepNumber}
                        items={[
                            {title: 'Select Assigned Test'},
                            {title: 'View Results and Recommend ' + brandConfig.diagnosticFeedbackName},
                            {title: brandConfig.diagnosticFeedbackName + ' Summary'}
                        ]}
                    />
                {/*</Card>*/}
            </div>
            {stepNumber === STEP_NUMBERS.TEST_ASSIGNMENTS.number &&
                <TestAssignments stepChange={handleStepChange} updateSelectedTestAssignmentData={handleTestAssignmentDataChange} editAssignObj={editAssignObj} resetTracking={handleResetTracking} refreshTestAssignmentSearch={refreshTestAssignmentSearch} />}
            {stepNumber === STEP_NUMBERS.SKILL_SELECT.number &&
                <SkillSelect stepChange={handleStepChange} testAssignmentData={selectedTestAssignmentData} updateSkillResources={handleUpdatedSkillResources}
                             updateStudents={handleStudentUpdate} updateStudentScores={handleStudentScoreUpdate}
                             trackedState={skillSelectTrackedState} updateTrackedState={handleUpdateSkillSelectTrackedState}
                             updateTestAssignmentSkillResourceMap={updateTestAssignmentSkillResourceMap}
                             textbookGridRef={textbookGridRef}
                             curriculumGridRef={curriculumGridRef}
                             trackedData={{
                                 dataSet: {value:trackedDataSet, update:handleDataSet},
                                 textbook: {
                                     colData: {value:trackedTextbookColumnData, update:handleTrackedTextbookColData},
                                     rowData: {value:trackedTextbookRowData, update:handleTrackedTextbookRowData},
                                     initialRowData: {value: trackedInitialTextbookRowData, update: handleTrackedInitialTextbookRowData},
                                     initialColData: {value: trackedInitialTextbookColData, update: handleTrackedInitialTextbookColData},
                                     dataInit: {value: trackedTextbookDataInit, update: handleTrackedTextbookDataInit}
                                 },
                                 curriculum: {
                                     colData: {value:trackedCurriculumColumnData, update:handleTrackedCurriculumColData},
                                     rowData: {value:trackedCurriculumRowData, update:handleTrackedCurriculumRowData},
                                     initialRowData: {value: trackedInitialCurriculumRowData, update: handleTrackedInitialCurriculumRowData},
                                     initialColData: {value: trackedInitialCurriculumColData, update: handleTrackedInitialCurriculumColData},
                                     dataInit: {value: trackedTextbookDataInit, update: handleTrackedCurriculumDataInit}
                                 },
                                 rawResults: {
                                     rowData:{value:trackedRawRowResults, update:handleUpdateRawRowResults},
                                     colData:{value:trackedRawColResults, update:handleUpdateRawColResults}
                                 },
                                    hasCurriculumData:{value:hasCurriculumData, update:handleUpdateHasCurriculumData}
                                 }}
                            />}
            {stepNumber === STEP_NUMBERS.SKILL_RESOURCE_SELECT.number &&
                <SkillResourceSelect stepChange={handleStepChange} testAssignmentData={selectedTestAssignmentData}
                                     studentSkillResourceIdsMap={studentSkillResourceIdsMap} students={selectedStudents} studentSkillScores={selectedStudentScores}
                                     selectedTestAssignmentSkillResourceDisabledMap={selectedTestAssignmentSkillResourceMap} />}
            {stepNumber === STEP_NUMBERS.ASSIGNED_FOLLOW_UP_WORK.number &&
                <AssignedFollowUpWork stepChange={handleStepChange} testAssignmentData={selectedTestAssignmentData} />}
        </div>
    );
}

export default AssignedTestsTab;
